module.exports = __webpack_public_path__ + "static/img/Stainless.471d33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Stainless.jpg
// module id = OBsQ
// module chunks = 0